export const BetrGrAV = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine AV',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'voller Beitrag',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'halber Beitrag',
  },
];
